import { createConfiguration, createFionaClient } from '../templates/ClientFactory'
import { ImpressionControllerApi } from 'generated/api/apis/ImpressionControllerApi'

const ImpressionsClient = () => {
	const client = new ImpressionControllerApi(createConfiguration())
	return {
		createImpression: createFionaClient(client.impressionControllerCreate.bind(client))
	}
}

type ImpressionsClient = ReturnType<typeof ImpressionsClient>
let ImpressionsClientInstance: ImpressionsClient
export const getImpressionsClient = (rebuild = false) => {
	if (rebuild || !ImpressionsClientInstance) {
		ImpressionsClientInstance = ImpressionsClient()
	}
	return ImpressionsClientInstance
}
